import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-depth-modal',
  templateUrl: './depth-modal.component.html',
  styleUrl: './depth-modal.component.scss'
})
export class DepthModalComponent {
  @Input() showDialog: boolean = false;
  @Output() showDialogChange = new EventEmitter<boolean>();


  onCancel() {
    this.showDialogChange.emit(false);
  }
}
